import React from 'react';
import './money.scss';

// مبلغ: «۴٬۲۰۰٬۰۰۰٬۰۰۰» و «چهار میلیارد و دویست میلیون تومان»
const ONES = ['', 'یک', 'دو', 'سه', 'چهار', 'پنج', 'شش', 'هفت', 'هشت', 'نه'];
const TEENS = ['ده', 'یازده', 'دوازده', 'سیزده', 'چهارده', 'پانزده', 'شانزده', 'هفده', 'هجده', 'نوزده'];
const TENS = ['', '', 'بیست', 'سی', 'چهل', 'پنجاه', 'شصت', 'هفتاد', 'هشتاد', 'نود'];
const HUNDREDS = ['', 'صد', 'دویست', 'سیصد', 'چهارصد', 'پانصد', 'ششصد', 'هفتصد', 'هشتصد', 'نهصد'];
const SCALES = ['', 'هزار', 'میلیون', 'میلیارد', 'هزار میلیارد'];

function threeDigits(n) {
  const parts = [];
  const h = Math.floor(n / 100);
  const rest = n % 100;
  if (h) parts.push(HUNDREDS[h]);
  if (rest >= 10 && rest < 20) parts.push(TEENS[rest - 10]);
  else {
    const t = Math.floor(rest / 10);
    const o = rest % 10;
    if (t) parts.push(TENS[t]);
    if (o) parts.push(ONES[o]);
  }
  return parts.join(' و ');
}

export function numberToPersianWords(value) {
  let n = Math.floor(Number(value));
  if (!Number.isFinite(n) || n <= 0) return '';
  if (n >= 1e15) return '';
  const groups = [];
  let i = 0;
  while (n > 0) {
    const g = n % 1000;
    // «هزار» نه «یک هزار»
    if (g) groups.unshift(g === 1 && i === 1 ? 'هزار' : `${threeDigits(g)}${SCALES[i] ? ` ${SCALES[i]}` : ''}`);
    n = Math.floor(n / 1000);
    i += 1;
  }
  return groups.join(' و ');
}

export const toLatinDigits = (s) =>
  String(s == null ? '' : s)
    .replace(/[۰-۹]/g, (d) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d)))
    .replace(/[٠-٩]/g, (d) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(d)));

// فقط رقم‌ها (برای ذخیره)
export const digitsOnly = (s) => toLatinDigits(s).replace(/\D/g, '').replace(/^0+(?=\d)/, '');

// نمایش: سه‌رقم‌سه‌رقم با ارقامِ فارسی
export const formatMoney = (digits) => (digits ? Number(digits).toLocaleString('fa-IR') : '');

// نمایشِ ارقام با حروفِ فارسی (مقدار همچنان با ارقامِ انگلیسی ذخیره می‌شود)
export const faDigits = (s) => String(s == null ? '' : s).replace(/\d/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[d]);

// سالِ جاریِ شمسی (اگر مرورگر تقویمِ شمسی نداشت: ۱۴۰۵)
export function currentJalaliYear() {
  try {
    const y = parseInt(
      toLatinDigits(new Intl.DateTimeFormat('fa-IR-u-ca-persian', { year: 'numeric' }).format(new Date())),
      10
    );
    if (y > 1390 && y < 1500) return y;
  } catch (e) {
    /* */
  }
  return 1405;
}

// فیلدِ مبلغ: سه‌رقم‌سه‌رقم جدا می‌شود و زیرِ فیلد، همان مبلغ با حروفِ فارسی به تومان نوشته می‌شود
export function MoneyField({ value, onChange, placeholder, className = '', ...rest }) {
  const words = value ? numberToPersianWords(value) : '';
  return (
    <div className={`money-field ${className}`}>
      <input
        type="text"
        inputMode="numeric"
        placeholder={placeholder}
        value={formatMoney(value)}
        onChange={(e) => onChange(digitsOnly(e.target.value))}
        {...rest}
      />
      {words && <span className="money-field__words">{words} تومان</span>}
    </div>
  );
}
